import { VIMEO_ORIGIN, VIMEO_ORIGIN_WWW } from 'pagesNew/Video/VideoContent/VideoContentForm'
import { validateRequired } from 'utils/validation'

const ALLOWED_ORIGINS = [VIMEO_ORIGIN_WWW, VIMEO_ORIGIN]

export const validateVideoLink = (value?: string) => {
  if (!value) {
    return undefined
  }

  if (ALLOWED_ORIGINS.find((origin) => value?.startsWith(origin))) {
    return undefined
  }

  return 'Only Vimeo videos starting with https:// are allowed'
}

export const validateVideoLinkRequired = (value?: string) => {
  if (!value) {
    return validateRequired(value)
  }

  return validateVideoLink(value)
}
